import { AbstractControl, ValidationErrors } from '@angular/forms';
/**
 * validator for chip-id
 * Validates that:
 * - Chip-id is 10 or 12 characters long
 * - All characters are uppercase alphanumeric
 * - Not all zeros (10 or 12 zeros)
 */
export function chipIdValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  
  if (!value) {
    return null;
  }
  const chipIdPattern = /^[A-Z0-9]{10}$|^[A-Z0-9]{12}$/;
  const allZeros10 = /^0{10}$/;
  const allZeros12 = /^0{12}$/;
  if (!chipIdPattern.test(value)) {
    return null;
  }
  if (allZeros10.test(value) || allZeros12.test(value)) {
    return { allZeros: true };
  }

  return null;
}
export function isChipId(value: string): boolean {
  if (!value) {
    return false;
  }
  const chipIdPattern = /^[A-Z0-9]{10}$|^[A-Z0-9]{12}$/;
  return chipIdPattern.test(value);
}
export function isVin(value: string): boolean {
  if (!value) {
    return false;
  }
  // VIN must be 17 characters and cannot contain spaces
  if (value.length !== 17 || value.includes(' ')) {
    return false;
  }
  return true;
}
